export default [
	{
		locale: 'en',
		text: 'English',
	},
	{
		locale: 'de',
		text: 'Deutsch',
	},
]
